export default {
    PEMBAYARAN_PIUTANG: 206,
    SETTLE_HUTANG_DEPOSIT: 207,
    CREATE_EXTERNAL_INVENTORY: 301,
    CUSTOMER_EDIT_PIUTANG: 208,
    CUSTOMER_VIEW : 209,
    CUSTOMER_CREATE : 210,
    CUSTOMER_EDIT : 211,
    CUSTOMER_EDIT_OVERLIMIT : 212,
};
